<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>

    <v-sheet color="backgroundGrayColor" width="100%"
             :style="'border: solid rgb(220, 220, 220); height: ' + containerHeight + 'px;'"
    >
      <v-row no-gutters justify="start" align-content="center">
        <p class="mx-16 mt-4 py-2 text-h6"> 社員紹介（社員報）は
          <a
              href="https://drive.google.com/file/d/1ug-k8kQexS4MkUtAnwypSMnmOf4kD7SZ/view"
              target="_blank"
          >
            こちら
          </a>
          です
        </p>
      </v-row>
      <v-row no-gutters justify="start" align-content="center">
        <p class="mx-16 py-2 text-h6">本件に関する問い合わせ先：コーポレート本部 （内線 (732)480）</p>
      </v-row>
      <v-container ref="container" class="mx-auto my-auto" :style="'height: ' + (containerHeight - 300) + 'px;'">
        <iframe id="frame"
                :width="iframeWidth" height="5200px"
                :style="'transform: scale(' + iframeScale + ');'"
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTr1kA-y9G3BNoSwmgq7Sp2BdErL1n47jq1E5cUe6P8UMWvrZYPAnPodGEqXeU4VZ3c-cIe7QkpEp9-/pubhtml">
        </iframe>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';
import { Logger } from 'aws-amplify';

const logger = new Logger('telephone_line');

export default {
  name: 'TelephoneLineView',
  components: {
    Title,
  },

  data() {
    return {
      title: 'レポートライン一覧表',
      subTitle: 'ニックネーム一覧',
      img: 'title_telephoneLine.svg',

      //社員紹介シートテキスト部分（画面上部）
      employeeIntro: [
        '社員紹介エクセルは<a href="https://docs.google.com/a/medrt.com/viewer?a=v&pid=sites&srcid=bWVkcnQuY29tfGthbnJpLWdycHxneDozNTA1OWRhYzQzMzcyM2Nh">こちら</a>です',
      ],
      containerHeight: 0,
    };
  },

  mounted() {
    const el = document.getElementById('frame');
    logger.info('mounted scroll width: ', el.contentWindow.document.body.scrollWidth);
    logger.info('mounted scroll height: ', el.contentWindow.document.body.scrollHeight);
    logger.info('mounted window width: ', window.innerWidth);

    this.$nextTick(() => {
      logger.info('nextTick');
      this.containerHeight = this.$refs.container.clientHeight;
      logger.info('containerHeight: ', this.containerHeight);
      this.onResize();
    });
  },

  methods: {
    onResize() {
      logger.info('onResize', this.containerHeight, this.iframeScale);

      // 5200pxはiframeのscale=1でちょうど高さが入りきるサイズ（スクロールバーが表示されない）
      // +300の調整は、フッターがiframeにかぶらない高さで調整している
      this.containerHeight = 5200 * this.iframeScale + 300;
    },

    /**
     * break point取得 xl以上でも独自に分岐する
     */
    getBreakPoint() {
      // 1920が社内WindowsPCの多い規程サイズ
      if (this.$vuetify.breakpoint.name === 'xl' && window.innerWidth >= 1921) {
        return 'xxl';
      }

      return this.$vuetify.breakpoint.name;
    },
  },

  computed: {

    /**
     * iframeの幅を動的に計算する
     */
    iframeWidth() {
      logger.info('iframeWidth 逆数:', 1 / this.iframeScale);

      // scaleの逆数を利用+実際の画面で調整した値
      return (1 / this.iframeScale * 100) + '%';
    },

    /**
     * iframeのスケールを動的に計算する
     */
    iframeScale() {
      switch (this.getBreakPoint()) {
        case 'xxl':
        case 'xl':
          return 0.8;
        default:
          return 0.58;
      }
    },
  },
};
</script>

<style scoped lang="scss">
iframe {
  // 左上基点
  transform-origin: 0 0;
}
</style>